import { IProductUnit, IProductDescription, IProductPrice } from '@lib/product';

export interface IOciSearchResponse {
    total: number;
    offset: number;
    limit: number;
    members: IOciArticle[];
    score: null;
}

export class OciArticle implements IOciArticle {
    attachment: string;
    attachmentPurpose: string;
    attachmentTitle: string;
    contract: string;
    contractItem: string;
    custField1: string;
    custField2: string;
    custField3: string;
    custField4: string;
    custField5: string;
    description: IProductDescription;
    extCategory: string;
    extCategoryId: string;
    extProductId: string;
    extQuoteId: string;
    extQuoteItem: string;
    extSchemaType: string;
    itemType: string;
    leadTime: number;
    longText: string;
    manufactCode: string;
    manufactMat: string;
    matGroup: string;
    matnr: number;
    parentId: number;
    price: IProductPrice;
    priceUnit: number;
    quantity: number;
    service: boolean;
    sldSysName: string;
    unit: IProductUnit;
    vendor: number;
    vendorMat: number;
    type: string;

    constructor(dto: IOciArticle) {
        this.attachment = dto.attachment;
        this.attachmentPurpose = dto.attachmentPurpose;
        this.attachmentTitle = dto.attachmentTitle;
        this.contract = dto.contract;
        this.contractItem = dto.contractItem;
        this.custField1 = dto.custField1;
        this.custField2 = dto.custField2;
        this.custField3 = dto.custField3;
        this.custField4 = dto.custField4;
        this.custField5 = dto.custField5;
        this.description = dto.description;
        this.extCategory = dto.extCategory;
        this.extCategoryId = dto.extCategoryId;
        this.extProductId = dto.extProductId;
        this.extQuoteId = dto.extQuoteId;
        this.extQuoteItem = dto.extQuoteItem;
        this.extSchemaType = dto.extSchemaType;
        this.itemType = dto.itemType;
        this.leadTime = dto.leadTime;
        this.longText = dto.longText;
        this.manufactCode = dto.manufactCode;
        this.manufactMat = dto.manufactMat;
        this.matGroup = dto.matGroup;
        this.matnr = dto.matnr;
        this.parentId = dto.parentId;
        this.price = dto.price;
        this.priceUnit = dto.priceUnit;
        this.quantity = dto.quantity;
        this.service = dto.service;
        this.sldSysName = dto.sldSysName;
        this.unit = dto.unit;
        this.vendor = dto.vendor;
        this.vendorMat = dto.vendorMat;
        this.type = dto.type;
    }

    public get compatibleToBasket(): boolean {
        return !!(
            (this.matnr || this.vendorMat) &&
            this.unit?.orderUnit &&
            this.unit?.contentUnit &&
            this.price?.currencyIso4217
        );
    }
}

export interface IOciArticle {
    description: IProductDescription;
    matnr: number;
    quantity: number;
    unit: IProductUnit;
    price: IProductPrice;
    priceUnit: number;
    leadTime: number;
    longText: string;
    vendor: number;
    vendorMat: number;
    manufactCode: string;
    manufactMat: string;
    matGroup: string;
    service: boolean;
    contract: string;
    contractItem: string;
    extQuoteId: string;
    extQuoteItem: string;
    extProductId: string;
    attachment: string;
    attachmentTitle: string;
    attachmentPurpose: string;
    extSchemaType: string;
    extCategoryId: string;
    extCategory: string;
    sldSysName: string;
    custField1: string;
    custField2: string;
    custField3: string;
    custField4: string;
    custField5: string;
    itemType: string;
    parentId: number;
    type: string;
}
